module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/rekreacja.jpg?8a0b8f02";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/rekreacja.jpg
// module id = 2329
// module chunks = 0